export const PRODUCT_VIEW_DETAILS_SCREENS = [
  'idealprofile',
  'sparendeposito',
  'sparen',
  'icmasbabonnement',
  'volmacht',
  'dienstverleningsovereenkomst',
  'rekeningcourant'
] as const;

export const PRODUCT_VIEW_URI: Record<typeof PRODUCT_VIEW_DETAILS_SCREENS[number], string> = {
  idealprofile: 'idealprofile',
  sparendeposito: 'sparendeposito',
  sparen: 'sparen',
  icmasbabonnement: 'icmasbabonnement',
  volmacht: 'volmacht',
  dienstverleningsovereenkomst: 'dienstverleningsovereenkomst',
  rekeningcourant: 'rekeningcourant'
}
